<template>
  <v-card flat>
    <v-card-text>
      <v-tabs
        grow
        v-model="tab"
        slider-size="3"
        background-color="green lighten-4"
      >
        <v-tab active-class="font-weight-bold">Meus Dados</v-tab>
        <v-tab active-class="font-weight-bold">Solicitações</v-tab>
      </v-tabs>
      <v-tabs-items v-model="tab">
        <v-tab-item>
          <v-card flat color="grey lighten-4" class="mt-2" rounded>
            <v-card-text>
              <v-alert type="warning" text v-if="temSolicitacaoPendente()"
                >Solicitação com pendências. Verifique!</v-alert
              >
              <v-form>
                <v-text-field
                  label="Rua/Avenida"
                  v-model="endereco"
                  disabled
                ></v-text-field>
                <v-text-field
                  label="Bairro"
                  v-model="bairro"
                  disabled
                ></v-text-field>
                <v-text-field
                  label="Número"
                  v-model="nro"
                  disabled
                ></v-text-field>
                <v-text-field label="Cep" v-model="cep" disabled></v-text-field>
                <v-text-field
                  label="Cidade/Estado"
                  v-model="cidadeUF"
                  disabled
                ></v-text-field>
                <modal-atualiz-endereco v-if="!temSolicitacaoPendente()" />
              </v-form>
            </v-card-text>
          </v-card>
        </v-tab-item>
        <v-tab-item>
          <v-alert
            v-if="filteredSolicitacoes.length == 0"
            type="info"
            text
            class="mt-3"
          >
            Não há solicitações para alteração de endereço
          </v-alert>
          <v-list color="grey lighten-4" class="mt-2 rounded-lg">
            <v-list-item
              v-for="(solic, i) in filteredSolicitacoes"
              :key="i"
              class="mt-2"
            >
              <v-list-item-icon v-if="!isMobile()">
                <v-chip small dark :style="colorStatus(solic.cores)">{{
                  solic.descstatus
                }}</v-chip>
              </v-list-item-icon>
              <v-list-item-content class="ml-2">
                <v-list-item-title>{{ solic.descsituacao }}</v-list-item-title>
                <v-list-item-subtitle class="caption"
                  >Solicitação realizada em
                  {{ formatarData(solic.datainicio) }} às
                  {{ solic.horainicio }}</v-list-item-subtitle
                >
                <v-list-item-subtitle v-if="isMobile()" class="mt-2">
                  <v-chip small dark :style="colorStatus(solic.cores)">{{
                    solic.descstatus
                  }}</v-chip></v-list-item-subtitle
                >
                <v-list-item-subtitle v-if="temSolicitacaoPendente()">
                  <modal-atualiz-endereco />
                </v-list-item-subtitle>
              </v-list-item-content>
              <v-list-item-action>
                <opcoes-solic-atualiz-cad :solic="solic" />
              </v-list-item-action>
            </v-list-item>
          </v-list>
        </v-tab-item>
      </v-tabs-items>
    </v-card-text>
  </v-card>
</template>

<script>
import { dateFormat } from "@/global";
import { mapGetters, mapState, mapActions } from "vuex";
import ModalAtualizEndereco from "./ModalAtualizEndereco.vue";
import OpcoesSolicAtualizCad from "./OpcoesSolicAtualizCad.vue";
export default {
  components: { ModalAtualizEndereco, OpcoesSolicAtualizCad },
  computed: {
    ...mapState("atualizacaoCadastral", ["dadosCadastrais", "solicitacoes"]),
    filteredSolicitacoes() {
      return this.solicitacoes.filter(
        (solic) => solic.codconfigsituacao === 43
      );
    },
  },
  data: () => ({
    tab: 0,
    endereco: "",
    bairro: "",
    nro: 0,
    cep: "",
    cidadeUF: "",
  }),
  methods: {
    ...mapGetters("atualizacaoCadastral", ["temSolicitacaoPendente"]),
    ...mapActions("atualizacaoCadastral", ["getSolicitacoes"]),
    formatarData(value) {
      return dateFormat(value);
    },
    colorStatus(colors) {
      return `background: rgba(${colors[0].cor},${colors[1].cor},${colors[2].cor},.7)`;
    },
    isMobile() {
      return this.$mq == "sm";
    },
  },
  mounted() {
    this.getSolicitacoes();
  },
};
</script>

<style></style>
